import { render, staticRenderFns } from "./slider.vue?vue&type=template&id=0223d4a2&scoped=true"
import script from "./slider.vue?vue&type=script&lang=js"
export * from "./slider.vue?vue&type=script&lang=js"
import style0 from "./slider.vue?vue&type=style&index=0&id=0223d4a2&prod&lang=scss&scoped=true"
import style1 from "./slider.vue?vue&type=style&index=1&id=0223d4a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-lo_658dcddb1d89a08c03476f5e8f9c1110/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0223d4a2",
  null
  
)

export default component.exports